import React,{useEffect,useState} from "react";
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import {Link} from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Spinner from "reactjs-simple-spinner";
import ProductsService from "../../../services/ProductsService";
import {toast, ToastContainer} from "react-toastify";


const initialproduct = {
    name: '',
    adminFee: 0,
    productType: '',
}

const EditProduct = () => {

    const [product, setProduct] = useState(initialproduct)
    const [loading, setLoading] = useState(false);

    const handleChange = name => ({ target: { value } }) => {
        setProduct({ ...product, [name]: value })
    }

   const handleUpdate = () => {
       console.log("product: ", product);
        setLoading(true);
        ProductsService.updateProduct(product).then(res => {
            console.log(res);
            if(res.status === 200){
                setLoading(false);
                toast.success('Product updated successfully')
            }
        }).catch(err => {
            console.log(err);
            setLoading(false);
            toast.warning('Product update failed\n Try again, If error persist kindly contact your administrator.')
        })

   }

   useEffect(() => {
       console.log("product: ", JSON.parse(localStorage.getItem('product')))
       setProduct(JSON.parse(localStorage.getItem('product')))
   }, [])

    return(
        <div>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div id="main-content" className="main-panel ps-container ps-theme-default">
              <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to="/products">
                                <a href>Products</a>    &nbsp;|&nbsp;
                            </Link>
                            <span className="text-capitalize">{product.name}</span>&nbsp;Product
                        </ul>
                        <div className="row mt">
                            <div className="col-lg-12">
                                <div className="content-panel">
                                    <div className="form container col-md-6 bg-white mt-5 p-5">
                                        {loading && (
                                            <div className="container">
                                                <form className="loader">
                                                    <div className="login-wrap p-5 mt-5">
                                                        <Spinner
                                                            size="large"
                                                            message="Please Wait..."
                                                            line-fg-color="#64c3c2"
                                                        />
                                                    </div>
                                                </form>
                                            </div>
                                        )}
                                        {!loading && (
                                        <form>
                                            <TextField
                                                autoFocus
                                                margin="dense"
                                                label="Name"
                                                className="text-uppercase"
                                                type="text"
                                                fullWidth
                                                value={product.title}
                                                onChange={handleChange('title')}
                                            />

                                            {/*<TextField*/}
                                            {/*    margin="dense"*/}
                                            {/*    label="Admin Fee"*/}
                                            {/*    type="text"*/}
                                            {/*    fullWidth*/}
                                            {/*    value={product.adminFee}*/}
                                            {/*    onChange={handleChange('adminFee')}*/}
                                            {/*/>*/}
                                            {/*<TextField*/}
                                            {/*    margin="dense"*/}
                                            {/*    label="Product Type"*/}
                                            {/*    type="text"*/}
                                            {/*    fullWidth*/}
                                            {/*    value={product.productType}*/}
                                            {/*    onChange={handleChange('productType')}*/}
                                            {/*/>*/}
                                            <Button onClick={handleUpdate} className="btn btn-block mt-4 mb-3 btn-primary">
                                                Update
                                            </Button>
                                        </form>
                                            )}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditProduct;
